import type { QboAccountingOption } from '../../features/invoicing/accountingApi';

/** Only a full USPS state name or its two-letter abbreviation is eligible. */
const US_STATE_CODES: Record<string, string> = {
  alabama: 'AL',
  alaska: 'AK',
  arizona: 'AZ',
  arkansas: 'AR',
  california: 'CA',
  colorado: 'CO',
  connecticut: 'CT',
  delaware: 'DE',
  florida: 'FL',
  georgia: 'GA',
  hawaii: 'HI',
  idaho: 'ID',
  illinois: 'IL',
  indiana: 'IN',
  iowa: 'IA',
  kansas: 'KS',
  kentucky: 'KY',
  louisiana: 'LA',
  maine: 'ME',
  maryland: 'MD',
  massachusetts: 'MA',
  michigan: 'MI',
  minnesota: 'MN',
  mississippi: 'MS',
  missouri: 'MO',
  montana: 'MT',
  nebraska: 'NE',
  nevada: 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  ohio: 'OH',
  oklahoma: 'OK',
  oregon: 'OR',
  pennsylvania: 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  tennessee: 'TN',
  texas: 'TX',
  utah: 'UT',
  vermont: 'VT',
  virginia: 'VA',
  washington: 'WA',
  'west virginia': 'WV',
  wisconsin: 'WI',
  wyoming: 'WY',
  'district of columbia': 'DC',
};
const KNOWN_CODES = new Set(Object.values(US_STATE_CODES));

/** Refuse guesses, ambiguous names, and accounting Locations such as "NY - Warehouse". */
export function matchShipToStateToLocationId(
  shipToState: string | null | undefined,
  locations: readonly QboAccountingOption[]
): string {
  const raw = String(shipToState ?? '')
    .trim()
    .replace(/\s+/g, ' ');
  const code = /^[a-z]{2}$/i.test(raw) ? raw.toUpperCase() : US_STATE_CODES[raw.toLowerCase()];
  if (!code || !KNOWN_CODES.has(code)) return '';
  const matches = locations.filter((option) => {
    const name = option.name.trim().replace(/\s+/g, ' ');
    return name.toUpperCase() === code || US_STATE_CODES[name.toLowerCase()] === code;
  });
  // An exact or full-name match is acceptable only when it identifies ONE QBO Location.
  return matches.length === 1 ? matches[0].id : '';
}
